import { render, staticRenderFns } from "./Mypage.vue?vue&type=template&id=2f2b33ec&"
import script from "./Mypage.vue?vue&type=script&lang=js&"
export * from "./Mypage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports